export default __webpack_public_path__ + "assets/models/7fc5a81e1ec15f9a0c0d06f2ca6a21c6.glb";